<div
  #message
  tabindex="-1"
  class="relative outline-none"
  [class.mb-[18px]]="available && reactions.length > 0"
  [style.min-width.px]="
    available && reactions.length > 0 ? (reactions.length > 1 ? 80 : 48) : null
  "
  cdkOverlayOrigin
  #anchor="cdkOverlayOrigin"
>
  <ng-content></ng-content>
  <div
    class="reaction-tools absolute top-1/2 -translate-y-1/2 flex items-center gap-[2px]"
    [class.reaction-tools-own]="ownMessage"
    [class.reaction-tools-active]="open"
    [class]="
      ownMessage
        ? 'right-[calc(100%+4px)] flex-row-reverse'
        : 'left-[calc(100%+4px)]'
    "
  >
    @if (enabled && available) {
    <button
      #trigger
      type="button"
      class="reaction-trigger sr-only focus-visible:not-sr-only focus-visible:min-h-[30px] focus-visible:min-w-[30px] tablet:not-sr-only tablet:min-h-[30px] tablet:min-w-[30px] items-center justify-center rounded-full text-grey dark:text-lightGrey hover:bg-primary/10 hover:text-primary-text dark:hover:text-primary focus-visible:outline-primary transition-colors duration-150"
      [attr.aria-label]="'DISCUSSION.REACT' | translate"
      aria-haspopup="dialog"
      [attr.aria-expanded]="open && reactionsVisible"
      (click)="open && reactionsVisible ? close() : show(false)"
    >
      <svg
        aria-hidden="true"
        class="block shrink-0"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
      >
        <circle cx="12" cy="12" r="9"></circle>
        <circle
          cx="9"
          cy="9"
          r="0.8"
          fill="currentColor"
          stroke="none"
        ></circle>
        <circle
          cx="15"
          cy="9"
          r="0.8"
          fill="currentColor"
          stroke="none"
        ></circle>
        <path d="M8 14a4.5 4.5 0 0 0 8 0"></path>
      </svg>
    </button>
    } @if (actionsEnabled) {
    <button
      #actionsTrigger
      cdkOverlayOrigin
      #actionsOrigin="cdkOverlayOrigin"
      type="button"
      class="reaction-trigger sr-only focus-visible:not-sr-only focus-visible:min-h-[30px] focus-visible:min-w-[30px] tablet:not-sr-only tablet:min-h-[30px] tablet:min-w-[30px] items-center justify-center rounded-full text-grey dark:text-lightGrey hover:bg-primary/10 focus-visible:outline-primary transition-colors duration-150"
      [attr.aria-label]="'MORE_ACTIONS' | translate"
      aria-haspopup="dialog"
      [attr.aria-expanded]="open && actionsVisible"
      (click)="open && actionsVisible ? close() : showActions()"
    >
      <svg
        aria-hidden="true"
        class="block shrink-0"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <circle cx="12" cy="5" r="1.8"></circle>
        <circle cx="12" cy="12" r="1.8"></circle>
        <circle cx="12" cy="19" r="1.8"></circle>
      </svg>
    </button>
    }
  </div>
  @if (available) {
  <div
    class="absolute -bottom-[18px] flex gap-[4px]"
    [class]="ownMessage ? 'left-[8px]' : 'right-[8px]'"
    aria-live="off"
    [attr.aria-busy]="state.view(targetKey)?.saving"
  >
    @for (emoji of emojis; track emoji; let index = $index) { @if (count(emoji))
    {
    <button
      type="button"
      class="reaction-pill flex h-[24px] min-w-[30px] items-center justify-center rounded-full bg-white dark:bg-black-dark shadow-sm focus-visible:outline-primary"
      [attr.aria-label]="
        ('DISCUSSION.EMOJI_' + names[index] | translate) + ': ' + people(emoji)
      "
      [attr.aria-pressed]="own(emoji)"
      [attr.aria-disabled]="!enabled"
      [matTooltip]="emoji + ' ' + people(emoji)"
      matTooltipPosition="above"
      matTooltipTouchGestures="off"
      [matTooltipShowDelay]="200"
      (click)="choose(emoji)"
    >
      <span
        class="flex h-full w-full items-center justify-center gap-[3px] rounded-full border px-[5px] text-xs leading-none transition-transform duration-200 motion-reduce:transition-none"
        [attr.data-reaction-emoji]="emoji"
        [class.reaction-confirm]="state.view(targetKey)?.desired === emoji"
        [class]="
          own(emoji)
            ? 'border-primary bg-primary/15'
            : 'border-borders-light dark:border-borders-darker'
        "
      >
        <span
          aria-hidden="true"
          class="text-[16px]"
          [class.opacity-70]="own(emoji) && state.view(targetKey)?.saving"
          >{{ emoji }}</span
        >@if (count(emoji) > 1) {<span>{{ count(emoji) }}</span
        >}
      </span>
    </button>
    } }
  </div>
  }
  <ng-template
    cdkConnectedOverlay
    #reactionOverlay="cdkConnectedOverlay"
    [cdkConnectedOverlayOrigin]="anchor"
    [cdkConnectedOverlayOpen]="open && reactionsVisible"
    [cdkConnectedOverlayPositions]="positions"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="12"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    (backdropClick)="close()"
    (detach)="close(false)"
    (attach)="attached(reactionOverlay)"
    (overlayKeydown)="keys($event)"
    (positionChange)="
      $event.scrollableViewProperties.isOriginOutsideView && close(false)
    "
  >
    <div
      #palette
      role="dialog"
      data-reaction-palette
      [attr.data-reaction-target]="targetKey"
      [cdkTrapFocus]="!actionsVisible"
      [attr.aria-label]="'DISCUSSION.REACT' | translate"
      animate.enter="reaction-enter"
      (animate.leave)="leave($event)"
      class="rounded-3xl border border-borders-light dark:border-borders-darker bg-white dark:bg-black-dark-lighter text-black dark:text-white p-0.5 shadow-xl max-w-[calc(100vw-24px)]"
    >
      <div class="flex items-center">
        @for (emoji of emojis; track emoji; let index = $index) {
        <button
          type="button"
          data-emoji
          class="reaction-option flex h-[44px] w-[44px] shrink-0 items-center justify-center rounded-full hover:bg-primary/10 focus-visible:bg-primary/10 focus-visible:outline-primary transition-colors duration-150"
          [class.reaction-hovered]="hovered === emoji"
          (pointerenter)="
            hovered = $event.pointerType === 'mouse' ? emoji : undefined
          "
          (pointerleave)="hovered = undefined"
          [attr.aria-label]="'DISCUSSION.EMOJI_' + names[index] | translate"
          [attr.aria-pressed]="own(emoji)"
          (click)="choose(emoji)"
        >
          <span
            aria-hidden="true"
            class="reaction-choice block text-[26px] leading-none"
            >{{ emoji }}</span
          >
        </button>
        }
      </div>
      <button
        type="button"
        class="sr-only focus:not-sr-only min-h-[44px] px-1"
        (click)="close()"
      >
        {{ "DISCUSSION.CANCEL" | translate }}
      </button>
    </div>
  </ng-template>
  <ng-template
    cdkConnectedOverlay
    #actionsOverlay="cdkConnectedOverlay"
    [cdkConnectedOverlayOrigin]="actionAnchor || anchor"
    [cdkConnectedOverlayOpen]="open && actionsVisible"
    [cdkConnectedOverlayPositions]="menuPositions"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="12"
    [cdkConnectedOverlayHasBackdrop]="!reactionsVisible"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    (backdropClick)="close()"
    (detach)="close(false)"
    (attach)="attached(actionsOverlay)"
    (overlayKeydown)="keys($event)"
    (positionChange)="
      $event.scrollableViewProperties.isOriginOutsideView && close(false)
    "
  >
    <div
      #actions
      role="dialog"
      data-discussion-actions
      [cdkTrapFocus]="!reactionsVisible"
      [attr.aria-label]="'MORE_ACTIONS' | translate"
      animate.enter="reaction-enter"
      (animate.leave)="leave($event)"
      class="min-w-[180px] max-w-[calc(100vw-24px)] max-h-[50dvh] overflow-y-auto rounded-2xl border border-borders-light dark:border-borders-darker bg-white dark:bg-black-dark-lighter text-black dark:text-white p-[4px] shadow-xl"
    >
      <ng-content select="[discussionActions]"></ng-content>
    </div>
  </ng-template>
</div>
@if (state.view(targetKey)?.error; as error) {
<p role="status" class="!m-0 text-xs text-form-error dark:text-form-errorLight">
  {{ error | translate }} @if (available && (enabled ||
  state.view(targetKey)?.reconciling)) {<button
    type="button"
    class="underline min-h-[44px]"
    (click)="state.retry(targetKey)"
  >
    {{ "DISCUSSION.RETRY" | translate }}</button
  >}
</p>
}
